import React, { useMemo } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import intl from 'react-intl-universal';
import { localizationUtils } from '@lifesize/clients.localization';
import { determineBrowserLocale } from '../utils/locale';

import FooterLink from './FooterLink';

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    width: '100%',
    backgroundColor: '#1f2933',
    color: '#fff',
    fontSize: '0.875rem',
    marginTop: theme.spacing(4)
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
    '@media (max-width: 50rem)': {
      flexDirection: 'column'
    }
  }
}));

export default function Footer() {
  const classes = useStyles();
  const locale = determineBrowserLocale();
  const languageId = useMemo(() => localizationUtils.getLanguageId(locale), [locale]);
  const privacyPolicyUrl = useMemo(() => localizationUtils.getPrivacyPolicy(languageId), [languageId]);
  const tosUrl = useMemo(() => localizationUtils.getTermsOfService(languageId), [languageId]);
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <span>{intl.get('components.Footer.copyright', { year: new Date().getFullYear() })}&nbsp;</span>
        <span>
          <FooterLink label={intl.get('components.Footer.legalLink')} url={process.env.REACT_APP_LEGAL_NOTICES_URL} />
          {' | '}
          <FooterLink label={intl.get('components.Footer.privacyPolicyLink')} url={privacyPolicyUrl} />
          {' | '}
          <FooterLink label={intl.get('components.Footer.tosLink')} url={tosUrl} />
        </span>
      </div>
    </footer>
  );
}
